import React from "react";
import { useSelector } from "react-redux";

import { useDropdownTemplateAvailability } from "@/Hooks/useGetTemplates";

import SendEmailBtn from "../Modals/SendEmailBtn";
import "./ContactPanel.css";
import { handleLinkClick } from "../LawFirmDirectoryDashboard/main";
const formatPhoneNumber = (number) => {
  if (!number) return null;
  const cleanedNumber = number.replace(/\D/g, "");

  const areaCode = cleanedNumber.slice(0, 3);
  const firstPart = cleanedNumber.slice(3, 6);
  const secondPart = cleanedNumber.slice(6);
  return `(${areaCode}) ${firstPart}-${secondPart}`;
};
const ContactPanel = ({
  id,
  panel_name,
  title1,
  title2,
  name,
  address1,
  address2,
  city,
  state,
  zip_code,
  phone_number,
  ext = "",
  fax_number,
  email,
  meetingurl,
  websiteURL,
  pageName = "",
  onSelectObject,
  buttonData,
  className = "",
  dynamic_label,
  genrate_doc_address,
  templateDropdownId,
  templatePageId,
  valueStyle = {},
  handleShowBlockHelp,
}) => {
  const currentPageId = useSelector((state) => state.page_id_click_record.page_id_click_record);
  const hasTemplateButton = buttonData?.some((button) =>
    /^(letter|generate document)$/i.test(button?.buttonText ?? "")
  );
  const { templatesAvailable } = useDropdownTemplateAvailability(
    templatePageId ?? currentPageId,
    templateDropdownId,
    { enabled: hasTemplateButton }
  );

  const isTemplateButtonDisabled = (button) =>
    button.disabled ||
    (/^(letter|generate document)$/i.test(button?.buttonText ?? "") && !templatesAvailable);

  return (
    <>
      <div
        className={`${pageName !== "litigation" ? "info-div" : "width-255 p-r-5"} ${className}`}
        style={{
          width: pageName !== "" && pageName?.startsWith("litigation") ? "" : "260px",
        }}
      >
        <div className="">
          <div onClick={onSelectObject}>
            <p
              className="bg-primary-5 columnsTitle text-center text-primary font-weight-semibold text-uppercase d-flex align-items-center justify-content-center position-relative"
              style={{
                // backgroundColor: "var(--primary-15)",
                height: "25px",
                whiteSpace: "nowrap",
              }}
            >
              {panel_name}
              {pageName === "litigation" && (
                <span
                  className="panel_help"
                  style={{
                    width: "25px",
                    height: "25px",
                    position: "absolute",
                    top: "0",
                    right: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (handleShowBlockHelp) {
                      handleShowBlockHelp();
                    }
                  }}
                >
                  ?
                </span>
              )}
            </p>
            {name?.trim() ? (
              <p
                style={{ backgroundColor: "var(--primary-2)", ...valueStyle }}
                className="font-weight-semibold text-capitalize p-r-5 p-l-5 text-truncated"
              >
                {name}
              </p>
            ) : (
              <p
                className="font-weight-semibold text-capitalize p-r-5 p-l-5"
                style={{
                  backgroundColor: "var(--primary-2)",
                }}
              >
                <span style={{ color: "var(--primary-25)" }}>
                  {dynamic_label?.trim() ? dynamic_label : "Full Name"}
                </span>
              </p>
            )}
            {pageName === "litigation" && (
              <>
                {title1 && (
                  <p
                    className="colFont m-0 font-weight-semibold p-r-5 p-l-5"
                    style={{
                      backgroundColor: "var(--primary-4)",
                      height: "21px",
                    }}
                  >
                    <span style={valueStyle}>{title1}</span>
                    {/* : (
                     <span
                       className="font-weight-semibold text-capitalize"
                       style={{ color: "var(--primary-25)" }}
                     >
                       {panel_name === "Judge & Department" ? "Department" : "Title 1"}
                     </span>
                   ) */}
                  </p>
                )}
                {title2 && (
                  <p
                    className="colFont m-0 font-weight-semibold p-r-5 p-l-5"
                    style={{
                      backgroundColor: "var(--primary-2)",
                      height: "21px",
                    }}
                  >
                    <span style={valueStyle}>{title2}</span>
                    {/* ) : (
                    <span
                      className="font-weight-semibold text-capitalize"
                      style={{ color: "var(--primary-25)" }}
                    >
                      {panel_name === "Judge & Department" ? "Clerk Name" : "Title 2"}
                    </span>
                  )} */}
                  </p>
                )}
              </>
            )}
            <div>
              <p
                className="inline-row-h-21 text-capitalize p-r-5 p-l-5"
                style={{
                  backgroundColor: "var(--primary-4)",
                }}
              >
                {address1 || address2 ? (
                  <p className="font-weight-semibold " style={valueStyle}>
                    {address1 && <span>{address1}</span>}
                    {address1 && address2 && <span>, </span>}{" "}
                    {/* Render comma only if both addresses exist */}
                    {address2 && <span>{address2}</span>}
                  </p>
                ) : (
                  <span
                    className="font-weight-semibold text-capitalize"
                    style={{
                      backgroundColor: "var(--primary-4)",
                      color: "var(--primary-25)",
                    }}
                  >
                    Address
                  </span>
                )}
              </p>

              <p
                className="inline-row-h-21 text-capitalize p-r-5 p-l-5"
                style={{
                  backgroundColor: "var(--primary-2)",
                }}
              >
                {city ? (
                  <span className="font-weight-semibold" style={valueStyle}>
                    {city},
                  </span>
                ) : (
                  <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                    city,
                  </span>
                )}{" "}
                {state ? (
                  <span className="font-weight-semibold" style={valueStyle}>
                    {state}
                  </span>
                ) : (
                  <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                    state
                  </span>
                )}{" "}
                {zip_code ? (
                  <span className="font-weight-semibold" style={valueStyle}>
                    {zip_code}
                  </span>
                ) : (
                  <span
                    className="font-weight-semibold "
                    style={{
                      color: "var(--primary-25)",
                      textTransform: "uppercase",
                    }}
                  >
                    zip
                  </span>
                )}
              </p>
            </div>
            <div>
              <p
                className="inline-row-h-21 p-r-5 p-l-5"
                style={{
                  backgroundColor: "var(--primary-4)",
                }}
              >
                {phone_number ? (
                  <span className="font-weight-semibold" style={valueStyle}>
                    {formatPhoneNumber(phone_number)}
                  </span>
                ) : (
                  <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                    (###) ###-####
                  </span>
                )}
                {ext && (
                  <>
                    <small
                      className="ms-1 font-weight-semibold"
                      style={{ color: "var(--primary-25)" }}
                    >
                      ext
                    </small>{" "}
                    <span className="font-weight-semibold" style={valueStyle}>
                      {ext}
                    </span>
                  </>
                )}
              </p>
              <p
                className="inline-row-h-21 p-r-5 p-l-5"
                style={{ backgroundColor: "var(--primary-2)" }}
              >
                {fax_number ? (
                  <span className="font-weight-semibold" style={valueStyle}>
                    {formatPhoneNumber(fax_number)}
                  </span>
                ) : (
                  <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                    (###) ###-####
                  </span>
                )}
                <span style={{ color: "var(--primary-25)" }} className="ms-1 font-weight-semibold">
                  fax
                </span>
              </p>
            </div>
            {pageName === "Experts" && websiteURL && (
              <div>
                <p
                  className="inline-row-h-21 p-r-5 text-center p-l-5"
                  style={{ backgroundColor: "var(--primary-4)" }}
                >
                  <a
                    href={websiteURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleLinkClick}
                    className="text-black p-l-5 p-r-5"
                  >
                    {websiteURL.replace(/^https?:\/\//, "")}
                  </a>
                </p>
              </div>
            )}
            {pageName === "litigation" && (
              <div>
                <p
                  className="inline-row-h-21 p-r-5 p-l-5 text-center"
                  style={{ backgroundColor: "var(--primary-4)" }}
                >
                  {websiteURL ? (
                    <span className="font-weight-semibold">{websiteURL}</span>
                  ) : (
                    <span className="fw-normal text-center" style={{ color: "var(--primary-25)" }}>
                      prefix.name.com
                    </span>
                  )}
                </p>
              </div>
            )}
            {pageName === "litigation_all_content" && meetingurl && (
              <div
                className="d-flex justify-content-center"
                style={{ backgroundColor: "var(--primary-4)" }}
              >
                <a
                  href={meetingurl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleLinkClick}
                  className="text-black p-l-5 p-r-5"
                >
                  {meetingurl.replace(/^https?:\/\//, "")}
                </a>
              </div>
            )}
          </div>
          {pageName === "treatment" && (
            <div>
              <p
                className="inline-row-h-21 p-r-5 text-center p-l-5"
                style={{ backgroundColor: "var(--primary-4)" }}
              >
                {websiteURL ? (
                  <a
                    href={websiteURL}
                    target="_blank"
                    className="font-weight-semibold"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    {websiteURL}
                  </a>
                ) : (
                  <a className="fw-normal" style={{ color: "var(--primary-25)" }}>
                    www.providerurl.com
                  </a>
                )}
              </p>
            </div>
          )}
          {pageName === "Defendants" && (
            <div>
              <p
                className="inline-row-h-21 p-r-5 text-center p-l-5"
                style={{ backgroundColor: "var(--primary-4)" }}
              >
                {websiteURL ? (
                  <a
                    href={websiteURL}
                    target="_blank"
                    className="font-weight-semibold"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    {websiteURL}
                  </a>
                ) : (
                  <a className="fw-normal" style={{ color: "var(--primary-25)" }}>
                    www.providerurl.com
                  </a>
                )}
              </p>
            </div>
          )}
          {pageName === "Case Loans" && (
            <div>
              <p
                className="inline-row-h-21 p-r-5 text-center p-l-5"
                style={{ backgroundColor: "var(--primary-4)" }}
              >
                {websiteURL ? (
                  <a
                    href={websiteURL}
                    target="_blank"
                    className="font-weight-semibold"
                    style={{
                      textDecoration: "none",
                      color: "black",
                    }}
                  >
                    {websiteURL}
                  </a>
                ) : (
                  <a className="fw-normal" style={{ color: "var(--primary-25)" }}>
                    www.insurancecompany.url
                  </a>
                )}
              </p>
            </div>
          )}
        </div>
        {pageName === "litigation" ? (
          <div className="" style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
            {buttonData?.map((button, index) => (
              <button
                type="button"
                id={index}
                style={{
                  backgroundColor: "var(--primary-10)",
                  borderColor: "var(--primary)",
                  color: isTemplateButtonDisabled(button) ? "var(--primary-25)" : "var(--primary)",
                  ...button.style,
                }}
                className={`btn btn-hover-contact-panel-row font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center ${button.className}`}
                disabled={isTemplateButtonDisabled(button)}
                onClick={() => button.onClick(id, genrate_doc_address)}
              >
                {button.iconClassName && <i className={`${button.iconClassName} me-1`} />}
                {button.imgSrc && (
                  <img className={button.imgClassName} src={button.imgSrc} alt="icon" />
                )}
                {button.buttonText}
              </button>
            ))}
            <SendEmailBtn email={email} pageName={"litigation"} />
          </div>
        ) : (
          <div className="">
            <SendEmailBtn email={email} />
            {buttonData?.map((button, index) => (
              <button
                type="button"
                id={index}
                style={{
                  backgroundColor: "var(--primary-10)",
                  borderColor: "var(--primary)",
                  color: isTemplateButtonDisabled(button) ? "var(--primary-25)" : "var(--primary)",
                  ...button.style,
                }}
                className={`btn btn-hover-contact-panel-row font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center ${button.className}`}
                disabled={isTemplateButtonDisabled(button)}
                onClick={() => button.onClick(id, genrate_doc_address)}
              >
                {button.iconClassName && <i className={`${button.iconClassName} me-1`} />}
                {button.imgSrc && (
                  <img className={button.imgClassName} src={button.imgSrc} alt="icon" />
                )}
                {button.buttonText}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(ContactPanel);
